import moment from "moment";
import { useEffect } from "react";
import styled from "styled-components";
import { RootState } from "../../store/rootReducer";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { objectToParams, paramsToObject } from "../../store/api";
import DokumenKerjasamaListPageList from "./DokumenKerjasamaListPageList";
import DokumenKerjasamaListPageFilter from "./DokumenKerjasamaListPageFilter";
import { getJenisDokumenAsync } from "../../reducers/jenisDokumen/jenisDokumen.actions";
import { getDokumenKerjasamaAsync, selectDokumenKerjasama } from "../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { PermissionMenuName } from "../../interfaces/UserRole";
import { getDepartmentAsync } from "../../reducers/department/department.actions";

/**
 * Main component for DokumenKerjasamaListPage. This
 * component is used to display page for Dokumen
 * Kerjasama list.
 * 
 * Calls for:
 * - DokumenKerjasamaListPageFilter
 * - DokumenKerjasamaListPageList
 */
export const DokumenKerjasamaListPage = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);
  /**
   * Redirect user to dokumen detail to create new dokumen
   * kerjasama
   */
  const createDokumenKerjasama = () => {
    dispatch(selectDokumenKerjasama(null));
    history.push(`/dokumen-kerjasama/create`);
  }

  /**
   * Redirect user to export excel page.
   */
  const exportExcel = () => {
    history.push(`/dokumen-kerjasama/export${location.search}`);
  }

  /**
   * Execute API calls based on filter provided in url
   * get parameters.
   * - Will only send filter parameters that exist.
   * - If no params were found, will set today's date
   *   as default
   */
  const refresh = () => {
    if (isLoading) return;
    const filter = paramsToObject(location.search);
    if (!filter) {
      history.push(`/dokumen-kerjasama${objectToParams({
        tanggal_awal: moment(new Date()).format('YYYY-MM-DD'),
        tanggal_akhir: moment(new Date()).format('YYYY-MM-DD')
      })}`);
      return;
    };
    if (filter.jenis_dokumen && filter.jenis_dokumen < 0) delete filter.jenis_dokumen;
    if (!filter.judul_kerjasama) delete filter.judul_kerjasama;
    if (!filter.tanggal_awal) delete filter.tanggal_awal;
    if (!filter.tanggal_akhir) delete filter.tanggal_akhir;
    if (!filter.tanggal_awal || !filter.tanggal_akhir) return;
    if (!filter.department) delete filter.department;
    if (!filter.sisa_berlaku) delete filter.sisa_berlaku;
    dispatch(getDepartmentAsync.request());
    dispatch(getJenisDokumenAsync.request({}));
    dispatch(getDokumenKerjasamaAsync.request(filter));
  }

  /**
   * Check for any changes in URL parameters. If so,
   * execute refresh()
   */
  useEffect(() => {
    refresh();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <DokumenKerjasamaListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-12">
            <div className="box">
              <div className="box-header">
                <h3 className="box-title">Saring Dokumen Kerjasama</h3>
              </div>
              <DokumenKerjasamaListPageFilter />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title" style={{marginBottom: '10px'}}>Daftar Dokumen Kerjasama</h3>

                <div className="box-tools">
                  {/* <button
                    disabled={isLoading}
                    className="btn btn-primary"
                    onClick={exportExcel}
                  >
                    Ekspor ke Excel
                  </button>
                  &nbsp; */}
                  <button
                    disabled={isLoading || !role.create}
                    className="btn btn-primary"
                    onClick={createDokumenKerjasama}
                  >
                    Tambah Baru
                  </button>
                </div>
              </div>
              <DokumenKerjasamaListPageList refresh={refresh} />
            </div>
          </div>
        </div>
      </section>
    </DokumenKerjasamaListPageWrapper>
  );
};

const DokumenKerjasamaListPageWrapper = styled.div``;
